<template>
    <div>
        <CardAdminComandos />
    </div>
</template>
<script>
    import CardAdminComandos from '../components/Config/CardAdminComandos'

    export default {
        components:{
            CardAdminComandos
        },
        data() {
            return {
                option: 0
            }
        },
        methods: {
            
        },
    }
</script>
<style lang="scss">
</style>